<template>
  <ol class="breadcrumb">
    <li class="breadcrumb-item" :key="index" v-for="(item, index) in list">
      <span class="active" v-if="isActiveBreadcrumb(index,item)">{{ showName(item) }}</span>
      <router-link :to="item" dis v-else>{{ showName(item) }}</router-link>
    </li>
  </ol>
</template>
<script>
export default {
  props: {
    list: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  created() {
    console.debug(this.list);
  },
  methods: {
    isActiveBreadcrumb(index, item) {
      return this.isLast(index) || item.props.hasOwnProperty('default') && !item.props.default.active;
    },
    isLast(index) {
      return index === this.list.length - 1
    },
    showName(item) {
      if (item.meta && item.meta.label) {
        item = item.meta && item.meta.label
        return this.$t(item);
      }
      if (item.name) {
        item = item.name
      }
      return item
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/Breadcrumb/Breadcrumb.vue